<template>
  <v-container fluid class="px-0 py-0">
    <v-tabs v-if="enableHistory" v-model="active">
      <v-tab>选课情况</v-tab>
      <v-tab>历史选课情况</v-tab>
      <v-tab-item>
        <template v-if="crudCfg1">
          <crud :cfg="crudCfg1" />
        </template>
      </v-tab-item>
      <v-tab-item>
        <template v-if="crudCfg2">
          <crud :cfg="crudCfg2" />
        </template>
      </v-tab-item>
    </v-tabs>
    <div v-else>
      <template v-if="crudCfg1">
        <crud :cfg="crudCfg1" />
      </template>
    </div>
  </v-container>
</template>
<script>
import { Crud } from "javaee-fre";
export default {
  name: "stuclazz-record-list",
  components: {
    crud: Crud,
  },
  data() {
    return {
      active: 0,
      crudCfg1: null,
      crudCfg2: null,
    };
  },
  watch: {
    active(v) {
      let self = this;
      if (v == 1 && !self.crudCfg2) {
        self.crudCfg2 = self.tabCfg(true);
      }
    },
  },
  computed: {
    enableHistory() {
      return this.$isInRole("ROLE_TENANT_SC_ARCH") || this.$isSuperman();
    }
  },
  methods: {
    clzstuMeta(i, a) {
      let self = this;
      let url = `/home/admin/my/tenant/stu/${a ? "a_" : ""}clzstu`;
      return {
        url: url,
        titleField: 'clazzName',
        params: self.$route.params,
        listActions: [{
          label: '导出', func() {
            let self = this;
            if (self.searching) {
              window.open(`${self.$const.baseUrl}${url}/r/export?${self.$qs.stringify(self.searchData())}&_stuId=${self.cfg.params._stuId}`);
            } else {
              window.open(`${self.$const.baseUrl}${url}/r/export?_stuId=${self.cfg.params._stuId}`);
            }
          }
        }],
        listItemActions: [{
          label: '学习详情', icon: 'more_horiz', func(cfg) {
            let self = this;
            self.$dialog.component(`学习详情 - ${cfg.item.clazzName}`, 'stuclazz-view', {
              fullscreen: true,
              ruleId: self.$dictVal(cfg.item.ruleId),
              clazzId: self.$dictVal(cfg.item.clazzId),
              id: cfg.item.id,
              archived: a,
            });
          }
        },
        {
          label: '人脸识别', icon: 'face', func(cfg) {
            let self = this;
            self.$dialog.crud(`人脸识别 - ${cfg.item.clazzName}`, {
              url: '/home/admin/my/tenant/clazz/stu/face',
              params: { _stuClazzId: cfg.item.id },
              deleteable: false,
              listItemFilter(i, facts) {
                let self = this;
                if (a || !self.$isSuperman()) {
                  self.delAction(facts, 'icon', 'face');
                }
                i.status._component = {
                  name: 'crud-list-avatar-item', cfg: {
                    label: i.status.name,
                    url: `${self.$const.baseUrl}/home/admin/my/tenant/clazz/stu/face/img/${i.path}?s=100x100`,
                    previewUrl: `${self.$const.baseUrl}/home/admin/my/tenant/clazz/stu/face/img/${i.path}`
                  }
                }
                return facts;
              },
              listItemActions: [{
                label: '设置为初始照片', icon: 'face', confirm: '确认将该照片设为初始比对照片吗？设置后将以该照片为比对基准，请确认照片清晰无误。', func(cfg) {
                  let self = this;
                  self.$axios.get(`/home/admin/my/tenant/clazz/stu/face/to/idphoto/${cfg.item.id}`, { params: self.cfg.params }).then(r => {
                    r = r.data;
                    if (r && r.status == 'ok') {
                      self.$status('设置成功～', 'success');
                      return;
                    }
                    self.$status(r && r.message ? r.message : '设置初始照片失败～', 'error');
                  });
                }
              }],
              fullscreen: true,
              selectStyle: 'multi'
            });
          }
        }],
        listItemFilter(i, acts) {
          if (i.faceSuccess === undefined) {
            acts.splice(acts.findIndex(a => a.icon == 'face'), 1);
          }
          return acts;
        }
      };
    },
    tabCfg(a) {
      let self = this;
      return self.clzstuMeta(null, a);
    },
    init() {
      let self = this
      self.crudCfg1 = self.tabCfg(false);
    },
  },
  created() {
    this.init();
  },
};
</script>
